import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import serverData from './utils/server-data'
import setupAnalytics from './utils/fpti'
import { loadDataDogRumInfo } from './utils/datadog-rum'

import { ContextProvider as GriffinContextProvider } from '@paypalcorp/worldready-react'
import screenMapper from './screens/screen-mapper'

const Home = React.lazy(() => import('./screens/home'))
const App = React.lazy(() => import('./app'))

const renderView = () => {
  const {
    isFlow = false,
    fpti = null,
    view: { name: viewName } = {},
    requestURI,
  } = serverData

  if (fpti) {
    setupAnalytics()
  }

  loadDataDogRumInfo(serverData.dataDogConfig)

  let root = document.getElementById('root'),
    component
  const flow = document.getElementById('flow')

  if (!root) {
    root = document.createElement('div')
    document.body.appendChild(root)
  }

  let screen = null
  if (viewName) {
    screen = screenMapper[viewName]
  }

  if (isFlow && screen) {
    component = (
      <Home isFlow {...screen.props}>
        <screen.view {...screen.props} />
      </Home>
    )
  } else {
    component = <App path="*" />
  }

  ReactDOM.render(
    <GriffinContextProvider locale={serverData.locality.locale}>
      <Suspense fallback={<div>...</div>}>
        <BrowserRouter basename={requestURI}>{component}</BrowserRouter>
      </Suspense>
    </GriffinContextProvider>,
    isFlow ? flow : root,
  )
}

export default renderView
